'use strict';
const sortedSubIdeas = require('@mindmup/mapjs-core/src/content/sorted-sub-ideas');
module.exports = function hierarchicalLabelGenerator(aggregate) {
	let lastAssigned = 0;
	const isGroup = function (idea) {
			return idea && idea.attr && idea.attr.group;
		},
		traverse = function (contentIdea, labels) {
			sortedSubIdeas(contentIdea).forEach(function (subIdea) {
				if (!isGroup(subIdea)) {
					labels[subIdea.id] =  String (++lastAssigned);
				}
				traverse(subIdea, labels);
			});
			return labels;
		};
	return traverse(aggregate, {});
};
